import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=c22db2fa&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=c22db2fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22db2fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c22db2fa')) {
      api.createRecord('c22db2fa', component.options)
    } else {
      api.reload('c22db2fa', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=c22db2fa&scoped=true&", function () {
      api.rerender('c22db2fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UEdrliZaySFi/JS/comp/CookieBox.vue"
export default component.exports